import {isLoggedIn} from '@github-ui/client-env'
import {Navigate} from '@github-ui/react-router'
import {useIsFeatureStateEnabled} from '../hooks/use-feature-state'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'

export function ArtifactsEntrypoint() {
  const {pullRequest} = useLayoutRouteData()
  const artifactsEnabled = useIsFeatureStateEnabled('artifacts')

  if (!isLoggedIn() || !artifactsEnabled) {
    return <Navigate to={pullRequest.pathName} replace />
  }

  return (
    <div id="artifacts-content" className="width-full" role="region" tabIndex={-1} aria-label="Artifacts">
      TODO: Pull request artifacts
    </div>
  )
}
